import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Box, Typography } from "@mui/material";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";

import { formatCurrency } from "../../utils/formatCurrency";
import { TotalAmountOfAssociatedOrders } from "./OrdersAssociatedRecords/TotalAmountOfAssociatedOrders";
import { AllocationSummary } from "./AllocationSummary";
import { formatDate } from "../../utils/dateUtils";

export const BankTransactionDetailHeader = () => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;
    const { category, document_date, amount, operational_centers } = recordContext.item;

    const categoriesToConsider = [91, 92, 93, 117, 124];


    return (
        <DetailHeader collection={recordContext.collection}>
            <Box minWidth={300} display="flex" columnGap={10} alignItems="flex-start">
                <Box>
                    <Typography variant="h6" color="secondary">
                        Movimento Bancário
                    </Typography>
                    <Box display="flex" columnGap={4} alignItems="flex-start">
                        {category?.name && <Typography variant="h5">{category?.name}: </Typography>}
                        <Typography variant="h5" sx={{ fontWeight: 0 }}>
                            {formatCurrency(amount, ".")}
                        </Typography>
                    </Box>
                    <Typography variant="body1">{formatDate(document_date)}</Typography>
                </Box>
                {categoriesToConsider.includes(category?.id) && (
                    <Box>
                        <TotalAmountOfAssociatedOrders bankTransaction={recordContext.item} orders={recordContext.item.orders} type="detail" />
                    </Box>
                )}
                {operational_centers && operational_centers.length > 0 && (
                    <Box>
                        <Typography variant="body1">Alocação de Custos</Typography>
                        <AllocationSummary operationalCenters={operational_centers} />
                    </Box>
                )}
            </Box>
      
        </DetailHeader>
    );
};
